// src/pages/Dashboard/components/AuthorNudge.jsx
// STATUS: active | UPDATED: 2026-09-24
// LOG:
//   2026-09-24  New. Jazz was getting the operator's dashboard card.
//
// WHAT JAZZ SEES INSTEAD OF THE COMMAND CENTRE.
//
// `AdminNudge` tells whoever is reading it that they are looking at the live
// member experience and points them at a page of switches to flip. That is
// Tyler's card. Pointed at Jazz it is slightly insulting: he is not inspecting
// the build, the method in it is his.
//
// Tyler, 2026-09-24: "make it look like a clean admin view for Jazz with no
// notes. We're going to talk more in human and interact with the coach only."
//
// ONE TRUE NUMBER, AND IT IS DELIBERATELY NOT A TO DO.
//
// The count is how many of his own confirmed lines and reasons the coach is
// teaching RIGHT NOW. Not how many are waiting, not a percentage, not a score.
// The whole tone problem with this product has been making him feel like he is
// behind on homework, and the honest inverse of that is showing him what has
// already left his head and reached a floor.
//
// It fails silent. A count that cannot be read shows the card without it,
// because a card that says "something went wrong" on a dashboard is worse than
// a card that simply says less.

import { useEffect, useState } from 'react'
import { Box, HStack, VStack, Text, Button } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { Sparkles } from 'lucide-react'
import { supabase } from '../../../lib/supabase'

export default function AuthorNudge({ firstName }) {
  const [applied, setApplied] = useState(null)

  useEffect(() => {
    let live = true
    supabase
      .from('method_contributions')
      .select('id', { count: 'exact', head: true })
      .eq('status', 'applied')
      .then(({ count, error }) => {
        if (live && !error && typeof count === 'number') setApplied(count)
      })
    return () => {
      live = false
    }
  }, [])

  return (
    <Box bg="surface" borderRadius="card" p={6} border="1px solid" borderColor="line">
      <HStack
        justify="space-between"
        flexDir={{ base: 'column', sm: 'row' }}
        align={{ base: 'stretch', sm: 'center' }}
        spacing={4}
      >
        <VStack align="stretch" spacing={1}>
          <HStack spacing={2}>
            <Sparkles size={15} aria-hidden="true" />
            <Text fontSize="sm" fontWeight={600} color="ink">
              {applied
                ? `${applied} things you have said are being taught right now.`
                : 'Everything happens in the coach.'}
            </Text>
          </HStack>
          <Text fontSize="sm" color="inkMuted" lineHeight={1.6} maxW="60ch">
            Otto has your method, your manuals and the whole system in front of him.
            {firstName ? ` Talk to him, ${firstName},` : ' Talk to him'} the way you would talk to
            somebody on your floor. He writes down what matters.
          </Text>
        </VStack>
        <Button as={RouterLink} to="/coach/" size="md" flexShrink={0}>
          Open the coach
        </Button>
      </HStack>
    </Box>
  )
}
